// import image_1 from "../../assets/img/Events/college-club-events-23/image1.webp";
// import image_2 from "../../assets/img/Events/college-club-events-23/image2.webp";
// import image_3 from "../../assets/img/Events/college-club-events-23/image3.webp";
// import image_4 from "../../assets/img/Events/college-club-events-23/image4.webp";

//HackOverflow 1.0
import image2 from "../../assets/img/Events/1.0/HackOverflow 1.0/DSC_0022.webp";
import image3 from "../../assets/img/Events/1.0/HackOverflow 1.0/DSC_0036.webp";
import image4 from "../../assets/img/Events/1.0/HackOverflow 1.0/DSC_0042.webp";
import image5 from "../../assets/img/Events/1.0/HackOverflow 1.0/DSC_0052.webp";
import image6 from "../../assets/img/Events/1.0/HackOverflow 1.0/DSC_0068.webp";
import image7 from "../../assets/img/Events/1.0/HackOverflow 1.0/DSC_0094.webp";
import image8 from "../../assets/img/Events/1.0/HackOverflow 1.0/DSC_0146.webp";
import image9 from "../../assets/img/Events/1.0/HackOverflow 1.0/DSC_0187.webp";
import image10 from "../../assets/img/Events/1.0/HackOverflow 1.0/DSC_0211.webp";
import image11 from "../../assets/img/Events/1.0/HackOverflow 1.0/DSC_0224.webp";
import image12 from "../../assets/img/Events/1.0/HackOverflow 1.0/DSC_8219.webp";

// import image13 from "../../assets/img/Events/1.0/day1/_MG_9817.jpg";
// import image14 from "../../assets/img/Events/1.0/day1/_MG_9839.jpg";
// import image15 from "../../assets/img/Events/1.0/day1/_MG_9971.jpg";


//HackOverflow 2.0
import image17 from "../../assets/img/Events/1.0/HackOverflow 2.0/_MG_8256.webp";
import image18 from "../../assets/img/Events/1.0/HackOverflow 2.0/_MG_8302.webp";
import image19 from "../../assets/img/Events/1.0/HackOverflow 2.0/DSC_0123.webp";
import image20 from "../../assets/img/Events/1.0/HackOverflow 2.0/DSC_0167.webp";
import image21 from "../../assets/img/Events/1.0/HackOverflow 2.0/DSC_0219.webp";
import image22 from "../../assets/img/Events/1.0/HackOverflow 2.0/DSC_0238.webp";
import image23 from "../../assets/img/Events/1.0/HackOverflow 2.0/DSC_0462.webp";
import image27 from "../../assets/img/Events/1.0/HackOverflow 2.0/DSC_7864.webp";
import image28 from "../../assets/img/Events/1.0/HackOverflow 2.0/DSC_7925.webp";
import image29 from "../../assets/img/Events/1.0/HackOverflow 2.0/DSC_8071.webp";
import image30 from "../../assets/img/Events/1.0/HackOverflow 2.0/IMG_8507.webp";


//day 3

// import image30 from "../../assets/img/Events/1.0/day3/DSC_0405.webp";
// import image31 from "../../assets/img/Events/1.0/day3/DSC_0506.webp";
// import image32 from "../../assets/img/Events/1.0/day3/DSC_0509.webp";
// import image33 from "../../assets/img/Events/1.0/day3/DSC_0513.webp";
// import image34 from "../../assets/img/Events/1.0/day3/DSC_0517.webp";
// import image35 from "../../assets/img/Events/1.0/day3/DSC_0524.webp";
// import image36 from "../../assets/img/Events/1.0/day3/IMG_8003.webp";
// import image37 from "../../assets/img/Events/1.0/day3/IMG_8059.webp";
// import image38 from "../../assets/img/Events/1.0/day3/IMG_8071.webp";
// import image39 from "../../assets/img/Events/1.0/day3/ssss.jpg";
// import image40 from "../../assets/img/Events/1.0/day3/_MG_8030.jpg";
// import image41 from "../../assets/img/Events/1.0/day3/_MG_8108.jpg";

//winner - HackOverflow 2.0
import image42 from "../../assets/img/pastwinners/First.webp";
import image43 from "../../assets/img/pastwinners/Second.webp";
import image44 from "../../assets/img/pastwinners/Third.webp";

//winner - HackOverflow 3.0
import ho3_winner1 from "../../assets/img/pastwinners/Winner 1 - Prize.webp";
import ho3_winner2 from "../../assets/img/pastwinners/Winner 2 - Prize.webp";
import ho3_winner3 from "../../assets/img/pastwinners/Winner 3 - Prize.webp";

// Aftermovies
import ho1Aftermovie from "../../assets/img/ho1.png";
import ho2Aftermovie from "../../assets/img/ho2.png";
import ho3Aftermovie from "../../assets/img/Events/1.0/HackOverflow 3.0/3.0.png";

//HackOverflow 3.0
import ho3_image1 from "../../assets/img/Events/1.0/HackOverflow 3.0/DSC06725.webp";
import ho3_image2 from "../../assets/img/Events/1.0/HackOverflow 3.0/DSC06951.webp";
import ho3_image3 from "../../assets/img/Events/1.0/HackOverflow 3.0/DSC07030.webp";
import ho3_image4 from "../../assets/img/Events/1.0/HackOverflow 3.0/DSC07142.webp";
import ho3_image5 from "../../assets/img/Events/1.0/HackOverflow 3.0/DSC07263.webp";
import ho3_image6 from "../../assets/img/Events/1.0/HackOverflow 3.0/DSC08607.webp";
import ho3_image7 from "../../assets/img/Events/1.0/HackOverflow 3.0/DSC08629.webp";
import ho3_image8 from "../../assets/img/Events/1.0/HackOverflow 3.0/DSC08645.webp";
import ho3_image9 from "../../assets/img/Events/1.0/HackOverflow 3.0/DSC08931.webp";
import ho3_image10 from "../../assets/img/Events/1.0/HackOverflow 3.0/DSC08937.webp";
import ho3_image11 from "../../assets/img/Events/1.0/HackOverflow 3.0/DSC_0145.webp";


export const filterableData = [
  // {
  //   name: "day 1",
  //   // src: "https://images.pexels.com/photos/933054/pexels-photo-933054.jpeg?auto=compress&cs=tinysrgb&w=800",
  //   src: test,
  //   title: "test",
  //   text: "test",
  // },
  {
    category: 'hackoverflow1',
    // image: 'https://hackoverflow3.blr1.cdn.digitaloceanspaces.com/Gallery/HO1/HO1%20Aftermovie.jpg',
    image: ho1Aftermovie,
    link: 'https://youtu.be/HILS0q8Pdn8?si=-l5T96EFA3WMzdoN'
  },
  {
    category: 'hackoverflow1',
    // image: 'https://hackoverflow3.blr1.cdn.digitaloceanspaces.com/Gallery/HO1/DSC_0022.webp',
    image: image2,
  },
  {
    category: 'hackoverflow1',
    // image: 'https://hackoverflow3.blr1.cdn.digitaloceanspaces.com/Gallery/HO1/DSC_0036.webp'
    image: image3
  },
  {
    category: 'hackoverflow1',
    // image: 'https://hackoverflow3.blr1.cdn.digitaloceanspaces.com/Gallery/HO1/DSC_0042.webp'
    image: image4
  },
  {
    category: 'hackoverflow1',
    // image: 'https://hackoverflow3.blr1.cdn.digitaloceanspaces.com/Gallery/HO1/DSC_0052.webp',
    image: image5
  },
  {
    category: 'hackoverflow1',
    // image: 'https://hackoverflow3.blr1.cdn.digitaloceanspaces.com/Gallery/HO1/DSC_0068.webp',
    image: image6,
  },
  {
    category: 'hackoverflow1',
    // image: 'https://hackoverflow3.blr1.cdn.digitaloceanspaces.com/Gallery/HO1/DSC_0094.webp',
    image: image7
  },
  {
    category: 'hackoverflow1',
    // image: 'https://hackoverflow3.blr1.cdn.digitaloceanspaces.com/Gallery/HO1/DSC_0146.webp',
    image: image8
  },
  {
    category: 'hackoverflow1',
    // image: 'https://hackoverflow3.blr1.cdn.digitaloceanspaces.com/Gallery/HO1/DSC_0187.webp',
    image: image9
  },
  {
    category: 'hackoverflow1',
    // image: 'https://hackoverflow3.blr1.cdn.digitaloceanspaces.com/Gallery/HO1/DSC_0211.webp',
    image: image10
  },
  {
    category: 'hackoverflow1',
    // image: 'https://hackoverflow3.blr1.cdn.digitaloceanspaces.com/Gallery/HO1/DSC_0224.webp',
    image: image11
  },
  {
    category: 'hackoverflow1',
    // image: 'https://hackoverflow3.blr1.cdn.digitaloceanspaces.com/Gallery/HO1/DSC_8219.webp',
    image: image12
  },
  
  // DAY 2
  {
    category: 'hackoverflow2',
    // image: 'https://hackoverflow3.blr1.cdn.digitaloceanspaces.com/Gallery/HO2/HO2%20Aftermovie.jpg',
    image: ho2Aftermovie,
    link: 'https://youtu.be/VqBp6znJSF4?si=CpLPilo2CJYruCUW'
  },
  {
    category: 'hackoverflow2',
    // image: 'https://hackoverflow3.blr1.cdn.digitaloceanspaces.com/Gallery/HO2/_MG_8256.webp',
    image: image17
  },
  {
    category: 'hackoverflow2',
    // image: 'https://hackoverflow3.blr1.cdn.digitaloceanspaces.com/Gallery/HO2/_MG_8302.webp',
    image: image18
  },
  {
    category: 'hackoverflow2',
    // image: 'https://hackoverflow3.blr1.cdn.digitaloceanspaces.com/Gallery/HO2/DSC_0123.webp',
    image: image19
  },
  {
    category: 'hackoverflow2',
    // image: 'https://hackoverflow3.blr1.cdn.digitaloceanspaces.com/Gallery/HO2/DSC_0167.webp',
    image: image20
  },
  {
    category: 'hackoverflow2',
    // image: 'https://hackoverflow3.blr1.cdn.digitaloceanspaces.com/Gallery/HO2/DSC_0219.webp',
    image: image21
  },
  {
    category: 'hackoverflow2',
    // image: 'https://hackoverflow3.blr1.cdn.digitaloceanspaces.com/Gallery/HO2/DSC_0238.webp',
    image: image22
  },
  {
    category: 'hackoverflow2',
    // image: 'https://hackoverflow3.blr1.cdn.digitaloceanspaces.com/Gallery/HO2/DSC_0462.webp',
    image: image23
  },
  {
    category: 'hackoverflow2',
    // image: 'https://hackoverflow3.blr1.cdn.digitaloceanspaces.com/Gallery/HO2/DSC_7864.webp',
    image: image27
  },
  {
    category: 'hackoverflow2',
    // image: 'https://hackoverflow3.blr1.cdn.digitaloceanspaces.com/Gallery/HO2/DSC_7925.webp',
    image: image28
  },
  {
    category: 'hackoverflow2',
    // image: 'https://hackoverflow3.blr1.cdn.digitaloceanspaces.com/Gallery/HO2/DSC_8071.webp',
    image: image29
  },
  {
    category: 'hackoverflow2',
    // image: 'https://hackoverflow3.blr1.cdn.digitaloceanspaces.com/Gallery/HO2/IMG_8507.webp',
    image: image30
  },
  // {
  //   name: "HackOverflow 2.0",
  //   src: image25,
  // },
  // {
  //   name: "day 2",
  //   src: image26,
  // },
  // {
  //   name: "day 2",
  //   src: image_4,
  // },

  // HackOverflow 3.0
  {
    category: 'hackoverflow3',
    image: ho3Aftermovie,
    link: 'https://youtu.be/YOUR_HO3_AFTERMOVIE_LINK' // Replace with actual HackOverflow 3.0 aftermovie link
  },
  {
    category: 'hackoverflow3',
    image: ho3_image1,
  },
  {
    category: 'hackoverflow3',
    image: ho3_image2,
  },
  {
    category: 'hackoverflow3',
    image: ho3_image3,
  },
  {
    category: 'hackoverflow3',
    image: ho3_image4,
  },
  {
    category: 'hackoverflow3',
    image: ho3_image5,
  },
  {
    category: 'hackoverflow3',
    image: ho3_image6,
  },
  {
    category: 'hackoverflow3',
    image: ho3_image7,
  },
  {
    category: 'hackoverflow3',
    image: ho3_image8,
  },
  {
    category: 'hackoverflow3',
    image: ho3_image9,
  },
  {
    category: 'hackoverflow3',
    image: ho3_image10,
  },
  {
    category: 'hackoverflow3',
    image: ho3_image11,
  },


  // DAY 3
  // {
  //   name: "day 3",
  //   src: image36,
  // },
  // {
  //   name: "day 3",
  //   src: image37,
  // },
  // {
  //   name: "day 3",
  //   src: image38,
  // },
  // {
  //   name: "day 3",
  //   src: image27,
  // },
  // {
  //   name: "day 3",
  //   src: image28,
  // },
  // {
  //   name: "day 3",
  //   src: image29,
  // },
  // {
  //   name: "day 3",
  //   src: image30,
  // },
  // {
  //   name: "day 3",
  //   src: image31,
  // },
  // {
  //   name: "day 3",
  //   src: image32,
  // },
  // {
  //   name: "day 3",
  //   src: image33,
  // },
  // {
  //   name: "day 3",
  //   src: image34,
  // },
  // {
  //   name: "day 3",
  //   src: image35,
  // },
  // Winners Section with Headers
  {
    category: 'winners',
    isHeader: true,
    headerText: 'HackOverflow 2.0'
  },
  {
    category: 'winners',
    // image: 'https://hackoverflow3.blr1.cdn.digitaloceanspaces.com/Gallery/Winners/First.webp',
    image: image42
  },
  {
    category: 'winners',
    // image: 'https://hackoverflow3.blr1.cdn.digitaloceanspaces.com/Gallery/Winners/Second.webp',
    image: image43
  },
  {
    category: 'winners',
    // image: 'https://hackoverflow3.blr1.cdn.digitaloceanspaces.com/Gallery/Winners/Third.webp',
    image: image44
  },
  {
    category: 'winners',
    isHeader: true,
    headerText: 'HackOverflow 3.0'
  },
  {
    category: 'winners',
    image: ho3_winner1
  },
  {
    category: 'winners',
    image: ho3_winner2
  },
  {
    category: 'winners',
    image: ho3_winner3
  },
];
